<template>
<div class="join">
         <p class="topOne">会员VIP</p>
     <div class="header"> <img src="../../assets/images/header.png" alt=""></div>
     <div class="verify seeOne" v-if="seeOne" name="mobile">请输入您的手机号</div>
     <input type="tel" placeholder="手机号" class="number" v-model="phon"   maxlength="11">
     <div v-if="isVcodeLogin" class="vcode-area">
       <input type="tel" placeholder="输入验证码" class="auth" v-model="vcode"   maxlength="6" >
       <div class="send" v-show="!active" @click="sendOne();popupVisible2">发送</div>
      <div class="news" v-show="active">
        <span class="agineOne">{{countOne}}s</span>
        <!-- <span class="thity">5</span><span v-show="secndes">s</span> -->
      </div>
     </div>
     <div v-else>
       <input type="password" placeholder="请填写密码" class="auth" v-model="pass"  maxlength="12" minlength="6">
     </div>
       <mt-popup v-model="popupVisible2" popup-transition="popup-fade" :modal="false" v-if="sendTne">
                   <p v-text="msg" class="onePen"></p>
        </mt-popup>

     <button class="register" @click="toForm">登 录</button>
     <div class="supportArea">
       <a href="javascript:;" class="link leftRegister" @click="goForgetPage">忘记密码?</a>
       <a href="javascript:;" class="link rightRegister" @click="changeLoginMode">{{ loginMode }}</a>
     </div>
      <div class="tips">未注册的手机号验证后自动创建卡逸客账户</div>

    </div>
</template>
<script>
import validation from "@/assets/js/validation";
import { DatetimePicker, Popup, Toast, Indicator, Radio } from "mint-ui";
import store from "@/vuex/store";
import { mapState } from "vuex";
import { log } from 'util';
import { getLoginVcodeAction, loginAccountWithVcodeAction, loginWithPasswordAction } from '@/assets/js/api'
import { setLoginSessionLocalStorage, getJPushID } from '@/assets/js/localStorage'
import { deviceId, deviceName, getPicture, getCurrentPosition } from '@/assets/js/nativeServices'
import { addUserAlias } from '@/assets/js/pushServices'

export default {
  name: "indexOne",
  data() {
    return {
      sendTne: true,
      popupVisible2: false,
      active: false,
      phon: "",
      vcode: "",
      pass: "",
      seeOne: false,
      countOne: 60,
      numS: "",
      msg: "",
      wsOne:"",
      downTime:"",
      isVcodeLogin: true,
      loginMode: "",
      loginModeArr: ["使用密码登录", "使用短信验证码登录"]
    };
  },
  computed: {
    phoneNum() {
      return this.$store.state.phoneNum;
    },

  },
  watch: {
    popupVisible2(val) {
      if (val) {
        setTimeout(() => {
          this.popupVisible2 = false;
        }, 800);
      }
    }
  },
  mounted () {
    this.loginMode = this.loginModeArr[0]
    this.$nextTick(() => {
      const deviceHeight = document.documentElement.clientHeight
      console.log(deviceHeight)
      document.getElementsByClassName('join')[0].style.height = deviceHeight + 'PX'
    })
  },
  methods: {
    timer(){
          setInterval(() => {
            const one = this.downTime;
                if (this.countOne > 1 && this.countOne <= one) {
                  this.countOne--;
                } else {
                  this.active = false;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            },
    // 发送验证码
    newSend(){          
        var regu1 = /^1\d{10}$/;
        if (regu1.test(this.phon)) {
          this.verify = false;
            // 获取验证码 
            getLoginVcodeAction(this.phon).then(res => {
                console.log(res)
                Indicator.close()
              if(res.s==0)
              {
               
                  this.active = true;
                  this.downTime=res.nextTime;
                  this.timer()
              }
              else
              {
                  this.active=false
              }

                this.numS = res.s;

                switch (res.s) {
                  case 0:
                     Indicator.close()
                    this.msg = "发送成功";
                    this.popupVisible2 = true;
                    break;
                  case 1026:
                     Indicator.close()
                    this.msg = "操作频繁,请稍后再试";
                    this.popupVisible2 = true;
                    break;
                  case 1001:
                     Indicator.close()
                     this.msg = "系统错误";
                    this.popupVisible2 = true;
                      break;
                  case 1022:
                     Indicator.close()
                    this.msg = "请输入正确的验证码";
                    this.popupVisible2 = true;
                  case 1008:
                     Indicator.close()
                    this.msg = "账号未激活";
                    this.popupVisible2 = true;
                    this.showLoading = false;
                    break;
                }
            })
            .catch(err=>{
               Indicator.close()
                Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration: 2500
                   }) 
                });
          } 
      },
    //发送验证码按钮
    sendOne() {
       if(!(/^1\d{10}$/.test(this.phon))){
              this.msg = "请输入正确的手机号";
              this.popupVisible2 = true;
            }else{
                  Indicator.open({
                      text: '发送中...',
                      spinnerType: 'fading-circle'
                });

              }
       setTimeout(this.newSend,1000)
    },
    checkLoginBack(){
        
        if(isLoginBack){
          console.log(response)
          if (response.s == 0) 
          {   
                this.$router.push({ name: "cardBag" });
                var newObj = 
                {
                    newPhone: this.phon,
                    uid: response.uid,
                    sessionId: response.sessionId,
                    sign: response.sign,
                    mode:response.mode
                };
              
                  if(!isDev)
                  {
              
                        NativeStorage.setItem
                        (
                          "newObj",newObj,
                          this.onGetSucc,
                          this.onGetError
                        );
                  }
                  uid = response.uid;
                  sessionId = response.sessionId;
                  sign=response.sign;
                  mode=response.mode;
                  isLoginSucc = true;
                  this.$store.commit("phone", this.phon);
            } 
            else if (response.s == 1040 || response.s == 1022 || response.s == 1023) 
            {
              this.msg = "请输入正确的验证码";
              this.popupVisible2 = true;
            } 
            else if (response.s == 1008)
            {
                this.msg = "用户不存在";
                this.popupVisible2 = true;
            } 
            else if (response.s == 1021) 
            {
              this.msg = "无效的手机号";
              this.popupVisible2 = true;
            }
            else if (response.s == 1021) 
            {
              this.msg = "系统繁忙";
              this.popupVisible2 = true;
            }
             else if (response.s == 1040) 
            {
              this.msg = "验证码不正确";
              this.popupVisible2 = true;
            }
        }
        else
        {
           setTimeout(this.checkLoginBack, 500);
        }
    },
    //  验证码登录
    toForm() {
      if(!this.phon){
        this.msg = "请输入正确的手机号";
        this.popupVisible2 = true;
      }
      if(!(/^1[3,4,5,7,8]\d{9}$/.test(this.phon))){
              this.msg = "请输入正确的手机号";
              this.popupVisible2 = true;
      }else if(/^\d{4}$/.test(this.vcode)){
              //  this.msg = "请输入正确的验证码";
              // this.popupVisible2 = true;
      }else if(this.isVcodeLogin && this.vcode==""){
              this.msg = "请输入正确验证码";
              this.popupVisible2 = true;
      } else if (!this.isVcodeLogin && this.pass==''){
              this.msg = "请输入正确密码";
              this.popupVisible2 = true;
    }
      if (this.isVcodeLogin && this.phon && this.vcode) {
        // 手机验证码登录 获取用户信息
        var channel = 1
        loginAccountWithVcodeAction(deviceId(), deviceName(), channel, this.phon, this.vcode, getJPushID()).then(res => {
          console.log("login vcode:", res)
          if (res.s == 0) {
            setLoginSessionLocalStorage(res.key, res.session, res.token, res.uid, deviceId())
            addUserAlias(res.uid)
            this.$router.push({ name: "cardBag" })
          }
          }).catch(err => {
        console.log('loginErro', err)
        })
      }
      if (!this.isVcodeLogin && this.phon && this.pass) {
        // 手机密码登录 获取用户信息
        var channel = 1
        loginWithPasswordAction(deviceId(), deviceName(), channel, this.phon, this.pass, getJPushID()).then(res => {
          if (res.s == 0) {
            setLoginSessionLocalStorage(res.key, res.session, res.token, res.uid, deviceId())
            addUserAlias(res.uid)
            this.$router.push({ name: "cardBag" })
          }
          }).catch(err => {
        console.log('loginErro', err)
        })
      }
    },
    changeLoginMode () {
      if (this.isVcodeLogin) {
        this.loginMode = this.loginModeArr[1]
        this.isVcodeLogin = false
      } else {
        this.loginMode = this.loginModeArr[0]
        this.isVcodeLogin = true
      }
    },
    goForgetPage () {
      this.$router.push({ name: "forget" })
    }
  }
};
</script>
<style scoped>
.join {
  position: relative;
}
.mint-popup{
  background: rgba(0, 0, 0, 0.8);
  font-size: 0.3rem;
  border-radius: 0.2rem;
      top: 40%;
      height:1.2rem;
}
.topOne{
  margin-top: 1rem;
  font-size: 0.6rem
}
p.onePen{
  text-align: center;
  height: 0.8rem !important;
line-height: 0.2rem;
   color: white;
width: 5.5rem;
margin-top: 0.5rem;
font-size: 0.55rem

}
p.topOne{
  font-size: 0.5rem;
  color: #000000;
  text-align: center;
  font-weight: 530;
  margin-top: 0.36rem;
}
div {
  font-size: 0.25rem;
  color: #b2b2b2;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  width: 2.5rem;
  height: 2.5rem;
  display: inline-block;
  text-align: center;
  margin-top: 1.5rem;
}
input {
  width:80%;
  height:1.2rem;
  font-size: 0.5rem;
  border-radius: 0.3rem;
  outline: none;
  display: block;
  margin: 0 auto;
  /* margin-left: 0.2rem; */
  text-indent: 0.35rem;
  border: none;
  border: 1px solid #d6d6d6;
  margin-top: 0.2rem;


}
input::-webkit-input-placeholder {

font-size: 0.45rem;
 color: rgba(0, 0, 0, 0.5)
}
.number {
  margin-top: 1rem;
}
.auth {
  margin-top: 0.55rem;
}
.register {
  width:80%;
  height: 1.2rem;
  background-image: linear-gradient(to right, #2ea4b0, #06789d);
  font-size: 0.5rem;
  color: white;
  margin: 0  auto;
  border-radius: 0.3rem;
  outline: none;
  border: none;
  margin-top: 0.5rem;
  display: block;
}
.tips {
  display: block;
  font-size: 0.45rem;
  color: #BBBBBB;
  text-align: center;
  bottom: 0.75rem;
  width: 100%;
  position: absolute;
}

.vcode-area {
  position: relative;
}

.send, .news {
  position: absolute;
  right: 14%;
  font-size: 0.45rem;
  color: rgba(0, 0, 0, 0.5);
  bottom: .16rem;
  border: rgba(0, 0, 0, 0.5) solid 0.03rem;
  border-radius: 0.11rem;
  width: 1.39rem;
  height: 0.83rem;
  line-height: 0.83rem;
  text-align: center;
}

.verify {
  color: red;
  position: absolute;
  top: 4.2rem;
  left: 2.72rem;
  font-size: 0.25rem;
}
.seeOne {
  left: 2.8rem;
}
.supportArea {
    width: 80%;
    text-align: center;
    margin: 0.25rem auto;
}
a.leftRegister {
    float: left;
}
a.link {
    color: #299EAD;
    font-size: 0.33rem;
}
a.rightRegister {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/indexOne.vue